import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchReligionsData = createAsyncThunk(
  "api/fetchReligions",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-religions/`);
    const data = await response.json();
    return data;
  }
);

const religionSlice = createSlice({
  name: "religion",
  initialState: {
    religiondata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReligionsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReligionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.religiondata = action.payload;
      })
      .addCase(fetchReligionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default religionSlice.reducer;
